import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CourseEntity, PaginatedCoursesResponse } from "../../services/courses/courses.types";

export type CourseState = {
  courses: CourseEntity[];
  loading: boolean;
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
};

const initialState: CourseState = {
  courses: [],
  loading: false,
  pagination: {
    total: 0,
    page: 1,
    pageSize: 10,
    totalPages: 0,
  },
};

const course = createSlice({
  name: "course",
  initialState,
  reducers: {
    clearCourse: (state) => {
      state.courses = [];
      state.loading = false;
      state.pagination = {
        total: 0,
        page: 1,
        pageSize: 10,
        totalPages: 0,
      };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCoursesWithPagination: (
      state,
      action: PayloadAction<PaginatedCoursesResponse>
    ) => {
      state.courses = action.payload.data;
      state.pagination = {
        total: action.payload.pagination.total,
        page: action.payload.pagination.page,
        pageSize: action.payload.pagination.limit,
        totalPages: action.payload.pagination.totalPages,
      };
      state.loading = false;
    },
    setCourses: (state, action: PayloadAction<CourseEntity[]>) => {
      state.courses = action.payload;
      state.loading = false;
    },
    addCourse: (state, action: PayloadAction<CourseEntity>) => {
      state.courses.unshift(action.payload);
    },
    updateCourse: (
      state,
      action: PayloadAction<{ id: number; data: CourseEntity }>
    ) => {
      const index = state.courses.findIndex(
        (lesson) => lesson.id === action.payload.id
      );
      if (index !== -1) {
        state.courses[index] = action.payload.data;
      }
    },
    deleteCourse: (state, action: PayloadAction<number>) => {
      state.courses = state.courses.filter(
        (courses) => courses.id !== action.payload
      );
    },
  },
});

export default course;
export const {
  addCourse,
  clearCourse,
  deleteCourse,
  setCourses,
  setCoursesWithPagination,
  setLoading,
  updateCourse,
} = course.actions;
